/**
 * Character set allowed in invoice address lines: letters, digits,
 * whitespace, and a small set of punctuation (# - / ,) that real addresses
 * commonly need. Duplicated in 3 callers before extraction — keep them in
 * sync via these shared constants.
 *
 *   - INVOICE_ADDRESS_REGEX         — required field (1+ chars must match)
 *   - INVOICE_ADDRESS_REGEX_OPTIONAL — optional field (empty string allowed)
 */
export const INVOICE_ADDRESS_REGEX = /^[A-Za-z0-9\s#\-/,]+$/;
export const INVOICE_ADDRESS_REGEX_OPTIONAL = /^[A-Za-z0-9\s#\-/,]*$/;
